import { render } from "./MyPage.vue?vue&type=template&id=39454e1e&ts=true"
import script from "./MyPage.vue?vue&type=script&lang=ts"
export * from "./MyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__